import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/sites/entitlementSummary/initialState.entitlementSummary.data';
import { v4 as uuidv4 } from 'uuid';

const EntitlementSummarySlice = createSlice({
  name: 'entitlementSummary',
  initialState,
  reducers: {
    setSummaryResult: (state, action) => {
      state.summaryResult = action?.payload
        ? action?.payload?.siteEntitlementsSummary?.map((item) => ({
            ...item,
            id: uuidv4(),
          }))
        : [];
      state.siteCount = action?.payload
        ? action?.payload?.totalQuantity
        : initialState.siteCount;
    },
    resetValues: (state) => {
      state.summaryResult = initialState.summaryResult;
      state.siteCount = initialState.siteCount;
    },
    resetInputs: (state) => {
      state.selectedDate = initialState.selectedDate;
      state.statusId = initialState.statusId;
      state.name = initialState.name;
      state.code = initialState.code;
      state.disableObject.isDate = initialState.disableObject.isDate;
      state.disableObject.isStatus = initialState.disableObject.isStatus;
      state.disableObject.isCode = initialState.disableObject.isCode;
      state.disableObject.isName = initialState.disableObject.isName;
      state.wnError = initialState.wnError;
      state.eid_Lockdown = initialState.eid_Lockdown;
      state.voyix_Owned = initialState.voyix_Owned;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload ? action.payload : null;
    },
    setName: (state, action) => {
      state.name = action.payload ? action.payload : initialState.name;
    },
    setCode: (state, action) => {
      state.code = action.payload ? action.payload : initialState.code;
    },
    setStatusId: (state, action) => {
      state.statusId = action.payload.value
        ? action.payload.value
        : initialState.statusId;
    },
    setStatusResult: (state, action) => {
      state.statusResult = action.payload
        ? action.payload
        : initialState.statusResult;
    },
    handleEntitlementEidLockdown: (state, action) => {
      state.eid_Lockdown = action?.payload?.value;
      state.eid_LockdownName = action?.payload?.name;
    },
    handleEntitlementVoyixOwned: (state, action) => {
      state.voyix_Owned = action?.payload?.value;
      state.voyix_OwnedName = action?.payload?.name;
    },
    handleSearchFilters: (state, action) => {
      state.activeSearch.effectiveDate = action?.payload?.effectiveDate;
      state.activeSearch.statusId = action?.payload?.status;
      state.activeSearch.eid_Lockdown = action?.payload?.eid_Lockdown;
      state.activeSearch.voyix_Owned = action?.payload?.voyix_Owned;
      state.activeSearch.serviceProductCode =
        action?.payload?.serviceProductCode;
      state.activeSearch.serviceProductName =
        action?.payload?.serviceProductName;
    },
  },
});

export const {
  setErpSearch,
  resetValues,
  resetInputs,
  setSummaryResult,
  setSelectedDate,
  setName,
  setCode,
  setStatusId,
  setStatusResult,
  handleEntitlementEidLockdown,
  handleEntitlementVoyixOwned,
  handleSearchFilters,
} = EntitlementSummarySlice.actions;
export default EntitlementSummarySlice.reducer;
